var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterNaked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3266 11.345C23.3339 11.5324 23.3363 11.7197 23.3363 11.9071C23.3363 17.588 19.3401 24.1463 12.0323 24.1463C9.78747 24.1463 7.70012 23.4309 5.94141 22.2129C6.25229 22.247 6.56802 22.2726 6.88859 22.2726C8.74986 22.2726 10.4642 21.5826 11.824 20.4242C10.0854 20.3987 8.61743 19.1467 8.11114 17.4432C8.35419 17.4943 8.6045 17.52 8.86047 17.52C9.22142 17.52 9.57186 17.4689 9.90778 17.3667C8.08851 16.9749 6.71821 15.2375 6.71821 13.1508C6.71821 13.1252 6.71821 13.1166 6.71821 13.0996C7.25439 13.4147 7.86807 13.6105 8.51971 13.6361C7.45221 12.861 6.7505 11.5409 6.7505 10.0504C6.7505 9.26683 6.94591 8.52581 7.2899 7.88703C9.24887 10.4933 12.1776 12.2052 15.4795 12.3841C15.4116 12.069 15.3769 11.7369 15.3769 11.4047C15.3769 9.02843 17.1558 7.10352 19.3506 7.10352C20.4931 7.10352 21.5251 7.62314 22.2494 8.45781C23.1562 8.27044 24.0057 7.91274 24.7745 7.41875C24.4765 8.42377 23.8475 9.26679 23.0254 9.79486C23.8297 9.69265 24.5968 9.46286 25.3082 9.12218C24.7745 9.98241 24.1026 10.7403 23.3266 11.345Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNaked);
export default __webpack_public_path__ + "static/media/twitterNaked.0fc94a0cf919add3b5177e24b0417b48.svg";
export { ForwardRef as ReactComponent };